import { Layers } from "lucide-react";

import { useTranslation } from "@/i18n";
import { formatNumberID } from "@/lib/format";
import { MetricCard } from "./metric-card";

interface WorkspacesCardProps {
  value: number;
  isLoading: boolean;
  isError: boolean;
}

export function WorkspacesCard({
  value,
  isLoading,
  isError,
}: WorkspacesCardProps) {
  const { t } = useTranslation();
  const caption =
    value === 0
      ? t("dashboard.workspaces.none")
      : value === 1
        ? t("dashboard.workspaces.single")
        : t("dashboard.workspaces.multiple", { count: formatNumberID(value) });
  return (
    <MetricCard
      label={t("dashboard.workspaces.label")}
      icon={Layers}
      isLoading={isLoading}
      isError={isError}
    >
      <div className="text-3xl font-medium text-ocean-800">
        {formatNumberID(value)}
      </div>
      <div className="mt-2 text-xs text-neutral-600">{caption}</div>
    </MetricCard>
  );
}
